import { Colors } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import { createSelector } from '@reduxjs/toolkit';
import { alphaSort } from 'vet-bones/utils';

import {
  BaseTableItemData,
  TableField,
} from 'src/containers/ProjectDiagram/components/modelList/types';
import { diagramSnapshotSelector } from 'src/selectors/diagramSnapshot';
import { projectSelector } from 'src/selectors/project';
import * as copy from 'src/templates/copy';
import { icons } from 'src/templates/icons';

export const modelFieldsSelector = <
  TableItem extends Record<
    string,
    BaseTableItemData<{ checked: boolean; hidden: boolean }>
  >
>(
  projectId: string
) =>
  createSelector(
    projectSelector(projectId),
    diagramSnapshotSelector(projectId),
    (project, diagram) =>
      project && diagram
        ? Object.values(project.modelsById)
            .filter(
              ({ id }) => !diagram.model.modelData.deletedModelIds?.includes(id)
            )
            .map(
              ({ id, name }) =>
                ({
                  cellClassName: 'sd-project-diagram-model-table-cell--center',
                  headerClassName:
                    'sd-project-diagram-model-table-cell--center',
                  id,
                  label: name,
                  leftIcon: icons.model,
                  rightIcon: diagram.model.modelData.hiddenModelIds.includes(id)
                    ? IconNames.EYE_OFF
                    : undefined,
                  rightIconColor: Colors.GRAY4,
                  sortLabelAsc:
                    copy.components.projectDiagram.modelList.table
                      .sortBooleanAsc,
                  sortLabelDesc:
                    copy.components.projectDiagram.modelList.table
                      .sortBooleanDesc,
                  value: id,
                } as TableField<TableItem>)
            )
            .sort(alphaSort((item) => item.label))
        : []
  );
